import OverflowPillList from "components/OverflowPillList";
import { idPropType } from "constants/app";
import { arrayOf, shape, string } from "prop-types";
import { useMemo } from "react";

const CategoriesCell = ({ categoryTypes = [] }) => {
  const items = useMemo(() => {
    return categoryTypes.map((type) => ({
      label: type.typeName,
      id: type.id,
    }));
  }, [categoryTypes]);

  return <OverflowPillList items={items} />;
};

CategoriesCell.propTypes = {
  categoryTypes: arrayOf(
    shape({
      id: idPropType,
      typeName: string,
    })
  ),
};

export default CategoriesCell;
